// src/services/alertService.js
import Swal from "sweetalert2";

const AlertService={
  /**
   * Show a toast notification (top-right)
   * @param {Object} options
   * @param {String} options.title - The message to display
   * @param {String} [options.icon='success'] - success | error | warning | info | question
   * @param {Number} [options.timer=4000] - Duration in milliseconds
   */
  show({
    title="Opération terminée",
    icon="success",
    timer=3000,
    position="top-end",
    showCloseButton = true,
    ...customOptions
  }={}) {
    return Swal.fire({
      toast: true,
      position,
      icon,
      title,
      showConfirmButton: false,
      
      showCloseButton, // ✅ allow manual closing
      timer,
      timerProgressBar: true,
      customClass: {
        popup: "swal-toast",
      },
      ...customOptions, // ✅ allows overriding anything
    });
  },


  // Quick helpers
  success(title="Succès !") {
    return this.show({ title, icon: "success" });
  },

  error(title="Une erreur s'est produite.") {
    return this.show({ title, icon: "error" });
  },

  warning(title="Attention !") {
    return this.show({ title, icon: "warning" });
  },

  info(title="Information") {
    return this.show({ title, icon: "info" });
  },

  /**
   * Show a confirmation dialog
   * @param {Object} options
   * @param {String} [options.title='Êtes-vous sûr ?']
   * @param {String} [options.text='Cette action est irréversible.']
   * @param {String} [options.confirmButtonText='Oui']
   * @param {String} [options.cancelButtonText='Annuler']
   * @param {String} [options.icon='question']
   * @returns {Promise<Boolean>} Resolves to true if confirmed, false otherwise
   */
  async confirm({
    title="Êtes-vous sûr ?",
    text="",
    confirmButtonText="Oui",
    cancelButtonText="Annuler",
    icon="question",
  }={}) {
    const result=await Swal.fire({
      title,
      text,
      icon,
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText,
      reverseButtons: true,
      focusCancel: true,
      customClass: {
        popup: "swal-confirm",
      },
    });

    return result.isConfirmed;
  },
};

export default AlertService;
